<template>
  <div>
    <!--<Header :mainHeader="true"/> -->
    <div>
      <slot />
    </div>
  </div>
</template>

<script>
//import Header from './Header.vue';

export default {
  name: 'AppLayout',
  components: {
   // Header,
  },
};
</script>

<style scoped>
.app-header {
  background: #2c3e50;
  color: #fff;
  padding: 1rem;
  text-align: center;
}
main {
  padding: 2rem;
}
</style>
